
import { createContext } from 'react';

const CoreGraphContext = createContext(null);

export default CoreGraphContext;